import Dispatch from '../Dispatcher';
import { fromEvent } from 'rxjs';
import { map, switchMap, tap, withLatestFrom, filter, take, share } from 'rxjs/operators';
import _ from 'lodash'
import clock from './clock'

var keyDowns = fromEvent(document, "keydown")
  .pipe(
    share()
  )

Dispatch.getAction('awaitBind')
  .pipe(
  )
  .subscribe(e => Dispatch.getState('view.details.selected.awaitingBind', e))

Dispatch.getAction('awaitBind')
  .pipe(
    filter(e => e),
    switchMap(e => keyDowns
      .pipe(
        take(1)
      )
    ),
    withLatestFrom(Dispatch.getState('layers'), Dispatch.getState('view.details.selected.id')),
    map(([action, layers, selected ]) => {
      const index = _.findIndex(layers, command => command.id === parseInt(selected))
      const currentIndex = _.findIndex(layers, command => command.keyBind?.keyCode === action.keyCode)
      let clonedLayers = _.cloneDeep(layers)
      clonedLayers[index].keyBind = { keyCode: action.keyCode, code: action.code }
      if (currentIndex !== -1) {
        clonedLayers[currentIndex].keyBind = null
      }
      return clonedLayers
    }),
  )
  .subscribe(e => Dispatch.nextState('layers', e))

  keyDowns
    .pipe(
      withLatestFrom(Dispatch.getState('layers')),
      map(([key,layers]) => _.find(layers, command => command.keyBind?.keyCode === key.keyCode)),
      filter(e => e),
      withLatestFrom(clock)
    )
    .subscribe(([selected, clock]) => Dispatch.nextAction('script.add.fromClock', {id: selected.id, layer: selected.layer, position: clock }))